import * as React from 'react';
import {
  Grid,
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import type ICompanyContactDetails from './CompanyInterfaces';

interface ICompanyDetailsProps {
  formValues: ICompanyContactDetails,
  setFormValues: (values: ICompanyContactDetails) => void,
}

const CompanyDetails: React.FC<ICompanyDetailsProps> = ({
  formValues, setFormValues,
}) => (
  <>
    <Grid container spacing={0}>
      <Grid lg={5} md={4} xs={12}>
        <Grid item>
          <Box p={2}>
            <Typography variant="h6">
              {'Contact Information'}
            </Typography>
          </Box>
          <Box p={2}>
            <TextField
              value=""
              id="contactName-value-input"
              disabled
              label="Name"
              variant="outlined"
              type="string"
              fullWidth
              // onChange={(event) => {
              // }}
            />
          </Box>
          <Box p={2}>
            <TextField
              value={formValues.email}
              id="email-value-input"
              label="Email"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempFormValues: ICompanyContactDetails = { ...formValues, email: inputVal };
                setFormValues(tempFormValues);
              }}
            />
          </Box>
          <Box p={2}>
            <TextField
              id="phone-value-input"
              disabled
              label="Phone"
              variant="outlined"
              type="string"
              fullWidth
              // onChange={(event) => {
              //   // const inputVal = event.target.value;
              //   // Company entity does not have phone.

              //   // const tempFormValues: ICompanyDetails = { ...formValues, phone: inputVal };
              //   // setFormValues(tempFormValues);
              // }}
            />
          </Box>
          <Box p={2}>
            <TextField
              id="title-value-input"
              disabled
              label="Title"
              variant="outlined"
              type="string"
              fullWidth
              // onChange={(event) => {
              //   const inputVal = event.target.value;
              //   // Company entity does not have title.

              //   // const tempFormValues: ICompanyDetails = { ...formValues, title: inputVal };
              //   // setFormValues(tempFormValues);
              // }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid lg={5} md={4} xs={12}>
        <Grid item>
          <Box padding={2}>
            <Typography variant="h6">
              {'Office Address'}
            </Typography>
          </Box>
          <Box p={2}>
            <TextField
              value={formValues.address1}
              id="address1-value-input"
              required
              label="Address 1"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempFormValues: ICompanyContactDetails = { ...formValues, address1: inputVal };
                setFormValues(tempFormValues);
              }}
            />
          </Box>
          <Box p={2}>
            <TextField
              id="address2-value-input"
              label="Address 2"
              variant="outlined"
              type="string"
              fullWidth
              // onChange={(event) => {
              //   const inputVal = event.target.value;
              //   // Company entity does not have address2.

              //   // const tempFormValues: ICompanyDetails = { ...formValues, address2: inputVal };
              //   // setFormValues(tempFormValues);
              // }}
            />
          </Box>
          <Box p={2}>
            <TextField
              value={formValues.city}
              id="city-value-input"
              required
              label="City"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempFormValues: ICompanyContactDetails = { ...formValues, city: inputVal };
                setFormValues(tempFormValues);
              }}
            />
          </Box>
          <Box p={2}>
            <TextField
              value={formValues.state}
              id="state-value-input"
              required
              label="State"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempFormValues: ICompanyContactDetails = { ...formValues, state: inputVal };
                setFormValues(tempFormValues);
              }}
            />
          </Box>
          <Box p={2}>
            <TextField
              value={formValues.zipCode}
              id="zipCode-value-input"
              required
              label="Zip Code"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempFormValues: ICompanyContactDetails = { ...formValues, zipCode: inputVal };
                setFormValues(tempFormValues);
              }}
            />
          </Box>
          <Box p={2}>
            <FormControlLabel
              disabled
              label="Billing Address same as Office Address"
              control={(
                <Checkbox color="primary" size="small" id="billing-same-as-office-radio-button" />
              )}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  </>
);

export default CompanyDetails;
